var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.4668 1C7.93636 1 7.42766 1.18061 7.05258 1.5021C6.67751 1.82359 6.4668 2.25963 6.4668 2.71429V7.28571C6.4668 7.74037 6.67751 8.17641 7.05258 8.4979C7.42766 8.81939 7.93636 9 8.4668 9C8.99723 9 9.50594 8.81939 9.88101 8.4979C10.2561 8.17641 10.4668 7.74037 10.4668 7.28571V2.71429C10.4668 2.25963 10.2561 1.82359 9.88101 1.5021C9.50594 1.18061 8.99723 1 8.4668 1Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0667 5.7998V7.05906C13.0667 8.22798 12.589 9.34902 11.7389 10.1756C10.8887 11.0021 9.73565 11.4665 8.53333 11.4665C7.33102 11.4665 6.17795 11.0021 5.32778 10.1756C4.47762 9.34902 4 8.22798 4 7.05906V5.7998",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5332 11.4668V14.8668",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.13281 14.8662H11.9328",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicIcon);
export default __webpack_public_path__ + "static/media/mic-icon.f8eb6ee7223acd90ec6671745f4d1923.svg";
export { ForwardRef as ReactComponent };